import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@material-ui/core';
import { isString } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';
import styles from './form.module.scss';

interface ISelectRHFProps {
  name: string;
  hasNoValue?: boolean;
  noValueText?: string;
  items: SelectItems;
  selectProps: Omit<SelectProps, 'name'>;
  fullWidth?: boolean;
  hideErrorMessage?: boolean;
}

function SelectRHF(props: ISelectRHFProps) {
  const {
    name,
    hasNoValue = false,
    noValueText = '',
    items,
    selectProps: { label },
    fullWidth,
    hideErrorMessage = false,
  } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorTxt = (errors[name]?.message as string) ?? null;
  const labelId = `${name}-label`;

  return (
    <FormControl variant="outlined" error={Boolean(errorTxt)} fullWidth={fullWidth}>
      <InputLabel shrink id={labelId}>
        {label}
      </InputLabel>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select {...props.selectProps} {...field} labelId={labelId}>
            {hasNoValue && <MenuItem value="">{noValueText}</MenuItem>}
            {items?.map((item, i) => {
              const val = isString(item) ? item : item.value;
              return (
                <MenuItem key={`${val}-${i}`} value={val}>
                  {isString(item) ? item : item.label}
                </MenuItem>
              );
            })}
          </Select>
        )}
      />
      {errorTxt && !hideErrorMessage && (
        <p className={styles.errorMessage}>{errorTxt}</p>
      )}
    </FormControl>
  );
}

export default SelectRHF;
